import Vue from 'vue'

const keypress = {
  number: (evt) => {
    const event = (evt) || window.event
    const charCode = (event.which) ? event.which : event.keyCode
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
      event.preventDefault()
      return false
    }
    return true
  },
  numberNoDecimal: (evt) => {
    const event = (evt) || window.event
    const charCode = (event.which) ? event.which : event.keyCode
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) {
      event.preventDefault()
      return false
    }
    return true
  },
  telInput: (evt) => {
    const event = (evt) || window.event
    const charCode = (event.which) ? event.which : event.keyCode
    if (((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) && charCode !== 43) {
      event.preventDefault()
      return false
    }
    return true
  }
}

Vue.prototype.$keypress = keypress

export default keypress
